import React from "react";
import Box from "@mui/material/Box";
import Stepper from "@mui/material/Stepper";
import Step from "@mui/material/Step";
import StepLabel from "@mui/material/StepLabel";
import Check from "@mui/icons-material/Check";
import { styled } from "@mui/material/styles";
import StepConnector, { stepConnectorClasses } from "@mui/material/StepConnector";
import { StepIconProps } from "@mui/material/StepIcon";
import { ltrTheme } from "../../Theme";
import { FmStepIcon } from "..";
import useWindowDiemensions from "../../Hooks/UseWindowDiemensions";
import { useTheme } from "../../Hooks/UseTheme";

import useStyles from "./FmStepper.style";

const QontoConnector = styled(StepConnector)(({ theme }: any) => ({
  ".MuiStepConnector-lineVertical": {
    marginLeft: "15px",
  },
  [`&.${stepConnectorClasses.alternativeLabel}`]: {
    // ...(theme.direction !== 'rtl'
    //   ? {top: 23, left: 'calc(-50% + 30px)', right: 'calc(50% + 30px)'}
    //   : {top: 23, left: 'calc(50% + 30px)', right: 'calc(-50% + 30px)'}),
    top: 23,
    left: "calc(-50% + 30px)",
    right: "calc(50% + 30px)",
  },
  [`&.${stepConnectorClasses.active}`]: {
    [`& .${stepConnectorClasses.line}`]: {
      borderColor: theme.palette.primary.main,
    },
  },
  [`&.${stepConnectorClasses.completed}`]: {
    [`& .${stepConnectorClasses.line}`]: {
      borderColor: theme.palette.primary.main,
    },
  },
  [`& .${stepConnectorClasses.line}`]: {
    borderColor: theme.palette.mode === "dark" ? theme.palette.grey[800] : "#7c7c7c",
    borderTopWidth: 2,
    borderLeftWidth: 2,
  },
}));

const ColorlibStepIconRoot = styled("div")<{
  ownerState: { completed?: boolean; active?: boolean };
}>(({ theme }: any) => ({
  backgroundColor: theme.palette.mode === "dark" ? theme.palette.grey[700] : "none",
  zIndex: 1,
  color: "#fff",
  width: "52px",
  height: "52px",
  display: "flex",
  borderRadius: "50%",
  justifyContent: "center",
  alignItems: "center",
  "& .QontoStepIcon-completedIcon": {
    color: "#fff",
    zIndex: 1,
    fontSize: 12,
    backgroundColor: theme.palette.primary.main,
    width: "45px",
    height: "45px",
    borderRadius: "50%",
    padding: "10px",
    cursor: "pointer",
  },
  "& .QontoStepIcon-circle": {
    width: "45px",
    height: "45px",
    borderRadius: "50%",
  },
}));

interface FmStepperProps {
  data: {
    icon: any;
    desktopLabel: string;
    mobileLabel: string;
  }[];
  activeItemIndex: number;
  onItemSelect: (index: number) => void;
}

export default function FmStepper({ data, activeItemIndex, onItemSelect }: FmStepperProps) {
  const { width } = useWindowDiemensions();
  const classes = useStyles();
  const theme = useTheme();
  const desktopScreen = theme.breakpoints.values.desktop;
  const isMobile = width < desktopScreen;

  let alternativeLabel = true;
  if (width < desktopScreen) {
    alternativeLabel = false;
  } else {
    alternativeLabel = true;
  }

  const renderIcon = ({ active, completed, className, icon }: StepIconProps) => {
    const itemIndex = (icon as any) - 1;
    const handleItemClick = () => onItemSelect(itemIndex);
    return (
      <ColorlibStepIconRoot ownerState={{ active }} className={className} onClick={() => completed && handleItemClick()}>
        {completed ? (
          <Check className="QontoStepIcon-completedIcon" />
        ) : (
          icon && data[itemIndex] && <FmStepIcon icon={data[itemIndex].icon} active={!!active} onClick={handleItemClick} />
        )}
      </ColorlibStepIconRoot>
    );
  };

  const getLabel = (item: { icon: any; desktopLabel: string; mobileLabel: string }) => (isMobile ? item.mobileLabel : item.desktopLabel);

  if (activeItemIndex === 2.5) {
    return <></>;
  }

  return (
    <Box
      sx={{
        ".MuiStepConnector-line": {
          borderColor: ltrTheme.palette.primary.main,
        },
        ".MuiStepper-horizontal": {
          marginLeft: "-24px",
        },
      }}
    >
      <Stepper
        activeStep={activeItemIndex}
        alternativeLabel={alternativeLabel}
        connector={<QontoConnector />}
        orientation={width < desktopScreen ? "vertical" : "horizontal"}
      >
        {data.map((item, index) => (
          <Step key={getLabel(item)} className={classes.singleStep}>
            <StepLabel StepIconComponent={renderIcon}>
              {isMobile && `0${index + 1}`}
              {isMobile && <br />}
              {getLabel(item)}
            </StepLabel>
          </Step>
        ))}
      </Stepper>
    </Box>
  );
}
